export function setRoles(data) {
  return {
    type: 'SET_ROLES',
    payload: data,
  };
};